module.exports = __webpack_public_path__ + "static/media/binance.bab14c92.png";